import React from 'react';

import {ISelect} from '../../../interface/ISelect';
import {documentUrlKeyLabel} from '../../Forms/Constants/IP/commonKeyLabel';
import {parseAttachedDocumentDisplayName} from '../../Forms/Utils/attachedDocumentUtils';

export const yesNo = [
  {value: true, label: 'Yes'},
  {value: false, label: 'No'}
];

export const monthlyYearly = [
  {value: 'monthly', label: 'Monthly'},
  {value: 'yearly', label: 'Yearly'}
];

export const ElectricityType = [
  {value: 1, label: 'Solar'},
  {value: 2, label: 'Wind'},
  {value: 3, label: 'Hydro Electricity'}
];

export const productType: ISelect[] = [
  {
    value: 'b2c',
    label: 'B2C'
  },
  {value: 'b2b', label: 'B2B'}
];

export const Title = {actionTitle: 'Actions'};
export const status = {actionTitle: 'Status'};
export const comments = {actionTitle: 'Comments'};
export const FullInfo = {title: 'Full Info'};

export const makeCheckKeyLabel = {
  STATUS_COMMENTS: {label: 'Status & Comments', key: 'status'},
  FULL_INFO: {label: 'Full Info', key: ''},
  STATUS: {label: 'Status', key: 'status'},
  COMMENT: {label: 'Comment', key: 'comment'}
};

export const facilityTypeIds = {
  headquarter: 11
};

export const attachedDocumentColumn = {
  title: documentUrlKeyLabel.tableColumnLabel,
  dataIndex: documentUrlKeyLabel.key,
  render: (value: string): any =>
    value
      ? React.createElement(
          'a',
          {
            href: value,
            target: '_blank',
            rel: 'noreferrer',
            title: parseAttachedDocumentDisplayName(value)
          },
          parseAttachedDocumentDisplayName(value, true)
        )
      : '-'
};
